var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatmap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 12,
    height: 11,
    fill: "#2F68E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 13,
    width: 12,
    height: 11,
    fill: "#2F68E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 13,
    width: 12,
    height: 11,
    fill: "#5B8BF4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 13,
    width: 12,
    height: 11,
    fill: "#93B5FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 28,
    width: 12,
    height: 11,
    fill: "#2F68E5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 28,
    width: 12,
    height: 11,
    fill: "#5B8BF4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28,
    width: 12,
    height: 11,
    fill: "#93B5FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 28,
    width: 12,
    height: 11,
    fill: "#A8B8EC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 43,
    width: 12,
    height: 10,
    fill: "#5B8BF4"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 43,
    width: 12,
    height: 10,
    fill: "#93B5FF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 43,
    width: 12,
    height: 10,
    fill: "#A8B8EC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 43,
    width: 12,
    height: 10,
    fill: "#A8B8EC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 57,
    width: 12,
    height: 11,
    fill: "#A8B8EC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 57,
    width: 12,
    height: 11,
    fill: "#A8B8EC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 57,
    width: 12,
    height: 11,
    fill: "#A8B8EC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 57,
    width: 12,
    height: 11,
    fill: "#A8B8EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmap);
export default __webpack_public_path__ + "static/media/heatmap.e23d900d2c50e64bdf93e4c0b839f70c.svg";
export { ForwardRef as ReactComponent };